/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Booking_Portal_Places_ManyInputs */

const en_booking_portal_places_many = /** @type {(inputs: Booking_Portal_Places_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} places`)
};

const pl_booking_portal_places_many = /** @type {(inputs: Booking_Portal_Places_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} miejsc`)
};

/**
* | output |
* | --- |
* | "{count} places" |
*
* @param {Booking_Portal_Places_ManyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_places_many = /** @type {((inputs: Booking_Portal_Places_ManyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_Places_ManyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_places_many(inputs)
	return en_booking_portal_places_many(inputs)
});